import logger from "shared/logger";

const endpoint = () => {
  if (process.env.NODE_ENV === "development") {
    return {
      API_ENDPOINT: "http://localhost:8080",
      WEB_ENDPOINT: "http://localhost:3000",
    };
  } else {
    return {
      API_ENDPOINT: "https://api.joinlokalyze.com",
      WEB_ENDPOINT: "https://joinlokalyze.com",
    };
  }
};

const { API_ENDPOINT, WEB_ENDPOINT } = endpoint();

logger.info(`using endpoints: ${API_ENDPOINT}/${WEB_ENDPOINT}`);

export { API_ENDPOINT, WEB_ENDPOINT };
